import { render, staticRenderFns } from "./SelectConfirm.vue?vue&type=template&id=28d335f6"
import script from "./SelectConfirm.vue?vue&type=script&lang=ts"
export * from "./SelectConfirm.vue?vue&type=script&lang=ts"
import style0 from "./SelectConfirm.vue?vue&type=style&index=0&id=28d335f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports